<div class="container row m1-2" *ngIf="job">
    <div class="col-md-4">
        <div>
            <h1>
                <strong>Job: {{ job.jobNumber }}</strong>
            </h1>
        </div>
        <div>
            <strong>Customer: {{ job.customerName }}</strong
            ><br />
            <strong>Description: {{ job.description }}</strong
            ><br />
            <strong>Location: {{ job.locationAddress }}</strong
            ><br />
            <!-- <strong>Home: {{ job.homePhone }}</strong> <br /> -->
            <strong>Phone: {{ job.cellPhone }}</strong> <br />
            <strong>Key Code: {{ job.keyCode }}</strong> <br />
            <p></p>
            <strong>{{ job.isQuoteJob ? 'Quoted Job' : 'Time and Material Job' }}</strong> <br />
            <p></p>
        </div>
        <div class="pb-3">
            <button type="button" class="btn btn-success mr-2" (click)="viewNotes()">View Notes</button>
            <button type="button" class="btn btn-primary mr-2" (click)="completeJob()" [disabled]="job.statusId !== 1" *ngIf="canSeeCompleteJob">Complete Job</button>
            <button type="button" class="btn btn-secondary ml-2" (click)="close()">Close</button>
        </div>
        <!-- time entry grid -->
        <div class="m-1" style="max-width: 500px; max-height: 300px" *ngIf="job">
            <dx-data-grid #timeGrid height="200" [dataSource]="timeEntries" keyExpr="id" [columnAutoWidth]="false" (onToolbarPreparing)="onToolbarPreparing($event)">
                <dxi-column dataField="created" caption="Date" format="shortDate" width="80"></dxi-column>
                <dxi-column dataField="quantity" caption="Time" width="80"></dxi-column>
                <dxi-column dataField="description" caption="Description" width="200"></dxi-column>
                <dxi-column dataField="employee.displayName" caption="User" width="100"></dxi-column>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="jobTime-search-grid"></dxo-state-storing>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button type="button" class="btn btn-sm btn-success mr-2" (click)="addTime()">Add Time</button>
                    <button type="button" class="btn btn-sm btn-danger mr-2" (click)="delete(timeGrid.instance.getSelectedRowsData()[0])">Delete</button>
                </div>
            </dx-data-grid>
        </div>
        <!-- materials grid -->
        <div class="m-1 pb-3" style="max-width: 500px; max-height: 300px" *ngIf="job">
            <dx-data-grid
                #dataGrid
                height="200"
                [dataSource]="materials"
                keyExpr="id"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="selectionChange($event)"
            >
                <dxi-column dataField="quantity" caption="Qty" width="80"></dxi-column>
                <dxi-column dataField="name" caption="Material" width="200"></dxi-column>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="jobLine-search-grid"></dxo-state-storing>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button type="button" class="btn btn-sm btn-success mr-2" (click)="addMaterial()">Add Material</button>
                    <button type="button" class="btn btn-sm btn-danger mr-2" (click)="delete(dataGrid.instance.getSelectedRowsData()[0])">Delete</button>
                </div>
            </dx-data-grid>
        </div>
    </div>
    <div class="col-md-8" *ngIf="job && canSeePurchaseOrderLineGrid">
        <div class="m-1 grid-fill">
            <dx-data-grid
                #dataGrid
                [dataSource]="purchaseOrderLines"
                keyExpr="id"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="selectionChange($event)"
                (onRowDblClick)="onRowDblClick($event)"
            >
                <dxi-column dataField="invoiceDate" caption="Date" width="80"></dxi-column>
                <dxi-column dataField="vendor" caption="Vendor" width="100" cellTemplate="linkTemplate"></dxi-column>
                <dxi-column dataField="description" caption="Description" width="300" cellTemplate="linkTemplate"></dxi-column>
                <dxi-column dataField="amount" alignment="left" caption="Amount" width="100">
                    <dxo-format type="currency" [precision]="2"></dxo-format>
                </dxi-column>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="purchaseOrderLine-search-grid"></dxo-state-storing>

                <dxo-summary>
                    <dxi-total-item column="amount" summaryType="sum" displayFormat="{0}" valueFormat="$#,##0.00"> </dxi-total-item>
                </dxo-summary>

                <div *dxTemplate="let cell of 'linkTemplate'">
                    <a [routerLink]="[]" (click)="addPurchaseOrder(cell.data)">{{ cell.value || '(blank)' }}</a>
                </div>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button type="button" class="btn btn-sm btn-success mr-2" (click)="addPurchaseOrder(null)">Add Purchase Order</button>
                    <button type="button" class="btn btn-sm btn-danger mr-2" (click)="delete(dataGrid.instance.getSelectedRowsData()[0])">Delete</button>
                </div>
            </dx-data-grid>
        </div>
    </div>
</div>
